module.exports = __webpack_public_path__ + "static/media/reflect.770b1b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/reflect.png
// module id = 562
// module chunks = 0